module.exports = __webpack_public_path__ + "img/not-found-320.28e0d9d249455081ac920735a0d608d6.png";